const configData =  {
    snsList: [
    ],
    menu:[
        {name:'회사소개', link:'https://kr.ncsoft.com/kr/index.do',target:'_blank'},
        {name:'이용약관', link:'https://www.plaync.com/policy/service',target:'_blank'},
        {name:'개인정보처리방침', link:'https://www.plaync.com/policy/privacy',target:'_blank',},
        {name:'청소년 보호 정책', link:'https://www.plaync.com/policy/youthpolicy',target:'_blank'},
        {name:'운영정책', link:'https://www.plaync.com/policy/operation/lineage',target:'_blank'},
    ],
    serviceName: 'lineage',
    copyrightStudio: 'Lineage ® is a registered trademark of NCSOFT Corporation.',
    copyrightCompany: `Copyright © NCSOFT Corporation. <br> <span class="reserved">All Rights Reserved.</span>`,
    infoCS : '주소 경기도 성남시 분당구 대왕판교로 644번길 12 PC 게임 고객상담 1600-0020 팩스 02-2186-3550',
    gradeTemplate: `
	<li class="footer-links-items item-grade">
	   <butotn class="grade-link">게임이용등급
		   <div class="grade-layer">
			   <dl>
				   <dt>제명</dt>
				   <dd>리니지(NON-PVP)</dd>
				   <dt>상호</dt>
				   <dd>(주)엔씨소프트</dd>
				   <dt>이용등급</dt>
				   <dd>청소년이용불가</dd>
				   <dt>등급분류번호</dt>
				   <dd>제CC-NP-190807-003호</dd>
				   <dt>등급분류일자</dt>
				   <dd>2019.09.07</dd>
				   <dt>제작,배급업 신고번호</dt>
				   <dd>제 1999-000001호</dd>
			   </dl>
			   <dl>
				   <dt>제명</dt>
				   <dd>리니지(PVP)</dd>
				   <dt>상호</dt>
				   <dd>(주)엔씨소프트</dd>
				   <dt>이용등급</dt>
				   <dd>청소년이용불가</dd>
				   <dt>등급분류번호</dt>
				   <dd>제CC-NP-190807-002호</dd>
				   <dt>등급분류일자</dt>
				   <dd>2019.09.07</dd>
				   <dt>제작,배급업 신고번호</dt>
				   <dd>제 1999-000001호</dd>
               </dl>
		   </div>
	   </butotn>
	</li>
	`
};

export {
    configData
}

